class CcRadioCheckboxes {
  observedElements = [];

  constructor(observedElements) {
    this.observedElements = observedElements;
  }

  subscribe() {
    this.observedElements.forEach(element => {
      element.addEventListener('change', this.handleChange.bind(this));
    });
  }

  handleChange(event) {
    if (event.target.checked) {
      if (this.getCountChecked() > 1) {
        this.observedElements.forEach((element) => {
          if (event.target !== element) {
            element.checked = false;
          }
        });
      }
    }
  }

  getCountChecked() {
    return this.observedElements.filter(element => element.checked).length;
  }

  getCheckedState() {
    return this.observedElements.map((element) => ({
      name: element.name,
      checked: element.checked,
      self: element,
    }));
  }
}